import { FC } from "react";
import { BaseTheme } from "./baseTheme";

type ThemeProps = {
  variant: string;
};
const Theme: FC<ThemeProps> = ({ variant }) => {
  return <BaseTheme variant={variant} />;
};
export default Theme;
